<template>
	<p-panel title="Bertha" v-if="selectedBlock">
		<template #toolbar>
			<v-toolbar-title class="subheading">
				<BerthaAIAssistant class="mr-1" style="display: inline-block;" height="1.2rem"></BerthaAIAssistant>
				<span v-if="selectedBlock && selectedBlock.type">({{ selectedBlock.type }})</span>
			</v-toolbar-title>
		</template>

		<component :is="selectedBlockAIPanel" :block="selectedBlock" :isAIWorking.sync="isAIWorking" />

		<v-dialog v-model="isAIWorking" width="500" persistent>
			<v-card>
				<v-card-title class="headline" primary-title> AI is working </v-card-title>
				<v-card-text>
					This action may take some time. Please, wait...
					<v-progress-linear :indeterminate="true"></v-progress-linear>
				</v-card-text>
			</v-card>
		</v-dialog>
	</p-panel>
</template>

<script>
import blocks from '../../index.js';
import PPanel from '../utils/PPanel.vue';
import BerthaAIAssistant from '../placeholders/BerthaAIAssistant.vue';

import AIService from '../../../../../services/AIService.js';

import { mapState } from 'vuex';
import { STORE_USER_NAME, STATE_TOKEN } from '../../../../../store_constants/user';

export default {
	name: 'BlockAIOptions',
	props: ['selectedBlock'],
	components: {
		PPanel,
		BerthaAIAssistant
	},
	data() {
		return {
			isAIWorking: false
		};
	},
	provide() {
		return {
			aiService: this.getAIService()
		};
	},
	computed: {
		...mapState(STORE_USER_NAME, { token: STATE_TOKEN }),
		macrosActive() {
			return localStorage.PlantUserMacrosActive == 'true';
		},
		selectedBlockAIPanel() {
			if (!this.selectedBlock) return false;

			const { type } = this.selectedBlock;
			if (blocks[type] && blocks[type].AIPanel) {
				return blocks[type].AIPanel;
			}

			return false;
		}
	},
	methods: {
		getAIService() {
			return new AIService(this.token);
		}
	}
};
</script>

<style></style>
